import React from 'react';
import {reset, Field, reduxForm} from 'redux-form';
import SubmitButton from "../common/SubmitButton";
import {settingValidate} from "./settingValidate.js";
import ValidatedInputField from '../common/form/ValidatedInputField';

let SettingsForm = props => {
    const {settings, handleSubmit} = props;

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-12">
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label"><b>Navn</b></label>
                        <div className="col-sm-10">
                            <Field
                                className="form-control clickable"
                                name="key"
                                component="select"
                            >
                                {
                                    settings.map((setting) => {
                                        if (!setting.isMultiple) {
                                            return null;
                                        }

                                        return <option key={setting.id} value={setting.id}>{setting.id.split('_').join(' ')}</option>
                                    })
                                }
                            </Field>
                        </div>
                    </div>
                    <Field
                        className="form-control"
                        name="value"
                        type="number"
                        component={ValidatedInputField}
                        label={'Værdi'}
                    />
                    <hr/>
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <SubmitButton/>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

const afterSubmit = (result, dispatch) =>
    dispatch(reset('settings'));

const afterSubmitFail = (errors) =>  {
    var errorElemName = Object.keys(errors)[0];
    var fieldObj = document.getElementsByName(errorElemName)[0];
    if (fieldObj) {
        fieldObj.focus();
    }
}

SettingsForm = reduxForm({
    form: 'settings',
    validate: settingValidate,
    enableReinitialize: true,
    onSubmitSuccess: afterSubmit,
    onSubmitFail: afterSubmitFail
})(SettingsForm);

export default SettingsForm;


// WEBPACK FOOTER //
// ./web/src/components/settings/SettingsForm.jsx